import React from 'react';
import { Box, Typography, Link as MuiLink } from '@mui/material';
import {
  PeopleAlt as PeopleIcon,
  Schedule as ClockIcon,
} from '@mui/icons-material';
import { appColors } from '../../Config/Theme';

interface HeadcountBottomBarProps {
  showingStart: number;
  showingEnd: number;
  showingTotal: number;
  viewLabel?: string;
  viewingCount: number;
  totalRosterCount: number;
  onSwitchToFullRoster: () => void;
  autoSyncSeconds: number;
}

const HeadcountBottomBar: React.FC<HeadcountBottomBarProps> = ({
  showingStart,
  showingEnd,
  showingTotal,
  viewLabel,
  viewingCount,
  totalRosterCount,
  onSwitchToFullRoster,
  autoSyncSeconds,
}) => (
  <Box
    sx={{
      bgcolor: appColors.surface.card,
      borderTop: `1px solid ${appColors.border.default}`,
      border: `1px solid ${appColors.border.default}`,
      borderRadius: '0 0 12px 12px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      px: 2,
      py: 1,
      flexWrap: 'wrap',
      gap: 1,
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <PeopleIcon sx={{ fontSize: 18, color: appColors.text.caption }} />
      <Typography variant="caption" sx={{ color: appColors.text.body }}>
        Showing {showingStart}–{showingEnd} of {showingTotal} people
      </Typography>
    </Box>

    {viewLabel && (
      <Typography variant="caption" sx={{ color: appColors.text.body }}>
        View: {viewLabel}
      </Typography>
    )}

    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <Typography variant="caption" sx={{ color: appColors.text.caption }}>
        Viewing {viewingCount} of {totalRosterCount} people
      </Typography>
    </Box>

    <MuiLink
      component="button"
      variant="caption"
      onClick={onSwitchToFullRoster}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        color: appColors.primary.main,
        fontWeight: 600,
        cursor: 'pointer',
        textDecoration: 'none',
        '&:hover': { textDecoration: 'underline' },
      }}
    >
      <PeopleIcon sx={{ fontSize: 16 }} />
      Switch to Full Roster
    </MuiLink>

    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <ClockIcon sx={{ fontSize: 16, color: appColors.text.caption }} />
      <Typography variant="caption" sx={{ color: appColors.text.caption }}>
        Auto-sync every {autoSyncSeconds}s
      </Typography>
    </Box>
  </Box>
);

export default HeadcountBottomBar;
